// src/pages/Profile/profileTourConfig.js

export const profileTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue sur votre Profil de Santé',
            description: 'Je vais vous faire découvrir toutes les sections de votre profil médical. Suivez le guide !',
            side: 'over',
        },
    },
    {
        element: '.profile__grid',
        popover: {
            title: '🏥 Votre Profil de Santé',
            description: 'Voici votre espace personnel où vous pouvez suivre votre historique médical et vos informations de santé en un coup d\'œil.',
            position: 'center',
        },
    },
    {
        element: '.profile__col--left',
        popover: {
            title: '📋 Colonne Gauche',
            description: 'La colonne gauche contient vos informations personnelles, générales, d\'assurance et contacts d\'urgence.',
            position: 'right',
        },
    },
    {
        element: '.profileCard',
        popover: {
            title: '👤 Carte de Profil',
            description: 'Vos informations personnelles principales : nom, email et numéro de téléphone. Votre identifiant patient unique (PTN) est affiché en haut.',
            position: 'right',
        },
    },
    {
        element: '.profile__generalCard',
        popover: {
            title: '📋 Informations Générales',
            description: 'Consultez vos informations médicales de base : sexe, groupe sanguin, taille, poids, maladies et date de dernière visite.',
            position: 'right',
        },
    },
    {
        element: '.profile__InsuranceCard',
        popover: {
            title: '🏥 Assurance Médicale',
            description: 'Vos informations d\'assurance santé avec le nom du prestataire et votre numéro de police d\'assurance.',
            position: 'right',
        },
    },
    {
        element: '.profile__EmergencyCard',
        popover: {
            title: '🚨 Contacts d\'Urgence',
            description: 'Vos contacts d\'urgence enregistrés. Ces personnes seront contactées en cas d\'urgence médicale.',
            position: 'right',
        },
    },
    {
        element: '.ph-card',
        popover: {
            title: '📖 Historique de Santé',
            description: 'Votre historique médical complet avec toutes vos informations personnelles, allergies, chirurgies et antécédents familiaux.',
            position: 'left',
        },
    },
    {
        element: '.ph-section--grid:nth-child(2)',
        popover: {
            title: '👤 Habitudes Personnelles',
            description: 'Informations sur vos habitudes de vie : tabagisme et consommation d\'alcool.',
            position: 'left',
        },
    },
    {
        element: '.ph-section--grid:nth-child(3)',
        popover: {
            title: '⚠️ Allergies',
            description: 'Liste de vos allergies enregistrées avec leur niveau de gravité. Important pour la prescription de médicaments.',
            position: 'left',
        },
    },
    {
        element: '.ph-section--grid:nth-child(4)',
        popover: {
            title: '🛠️ Historique Chirurgical',
            description: 'Toutes vos interventions chirurgicales passées avec leurs dates.',
            position: 'left',
        },
    },
    {
        element: '.ph-section--grid:nth-child(5)',
        popover: {
            title: '👨‍👩‍👧‍👦 Historique Familial',
            description: 'Antécédents médicaux de votre famille. Utile pour évaluer les risques génétiques de certaines maladies.',
            position: 'left',
        },
    },
    {
        element: '.mq',
        popover: {
            title: '❓ Questions Médicales',
            description: 'Vos questions médicales publiées sur la plateforme. Vous pouvez voir le nombre de réponses reçues pour chaque question.',
            position: 'left',
        },
    },
    {
        element: '.mq__see',
        popover: {
            title: '👀 Voir Toutes les Questions',
            description: 'Cliquez sur "See All" pour voir l\'intégralité de vos questions médicales et leurs réponses.',
            position: 'bottom',
        },
    },
    {
        element: '.fd-card',
        popover: {
            title: '👨‍⚕️ Médecins Suivis',
            description: 'Liste des médecins que vous suivez. Vous pouvez leur envoyer des messages directement en cliquant sur l\'icône d\'envoi.',
            position: 'left',
        },
    },
    {
        element: '.fd-item__action',
        popover: {
            title: '✉️ Envoyer un Message',
            description: 'Cliquez sur cette icône pour envoyer un message direct à un médecin que vous suivez.',
            position: 'top',
        },
    },
    {
        element: '.fm-card',
        popover: {
            title: '👨‍👩‍👧 Membres de la Famille',
            description: 'Gérez les profils de santé de votre famille. Vous pouvez basculer entre les profils pour voir leurs informations médicales.',
            position: 'left',
        },
    },
    {
        element: '.fm-add',
        popover: {
            title: '➕ Ajouter un Membre',
            description: 'Cliquez sur ce bouton pour ajouter un nouveau membre de votre famille à la plateforme.',
            position: 'left',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous connaissez maintenant toutes les sections de votre profil de santé. N\'oubliez pas de le tenir à jour pour un meilleur suivi médical !',
            side: 'over',
        },
    },
];